import { NODE_TYPES, POPOVER_ROLE } from 'consts/enum';
import { api } from 'helpers/api';
import { generate6DigitUUID, isMobileOrTablet, setCustomTagHTML } from 'helpers/helpers';

import Form from '../nodes/FormNode/form.module';
import { Carousel } from '../UI/carousel/carousel.module';
import OtherChannelNodeTemplate from './otherChannelNode';

export default class OtherChannelNode {
	constructor(props) {}

	static async initializeComponent(props) {
		const object = new OtherChannelNode();
		await object.initData(props);
		object.initWrapper();
		return object.render();
	}

	getNodeData(bot, node, user, locale, key) {
		const ref = this;
		const camelToSnakeCase = (str) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

		const keyarg = node === NODE_TYPES.SEND_CAROUSEL ? `&key=${key}` : '';
		return api(
			'GET',
			`${window.location.origin}/fetchNodeDetails/bot/${bot}/user/${user}/?type=${
				node === NODE_TYPES.SEND_CAROUSEL ? node : NODE_TYPES.IDENTITY
			}${locale ? `&locale=${locale}` : ''}${keyarg}`,
			{
				payload: JSON.stringify({
					locale,
					type: node,
					key: node === NODE_TYPES.SEND_CAROUSEL ? key : undefined,
				}),
				allowRejects: false,
			}
		)
			.then((resp) => {
				if (resp) {
					const response = JSON.parse(resp.responseText);
					if (resp.status === 200) {
						if (node === NODE_TYPES.FORM_NODE || node === NODE_TYPES.IDENTITY) {
							const { attributes } = response.msg;
							const updatedAttributes = [...attributes];
							const originalAttributes = [];
							updatedAttributes.map((attribute) => {
								const originalAttrObject = {};
								Object.keys(attribute).map((key) => {
									attribute[`${camelToSnakeCase(key)}`] = attribute[key];
									originalAttrObject[key] = attribute[key];
									if (camelToSnakeCase(key) !== key) {
										delete attribute[key];
									}
								});
								originalAttributes.push(originalAttrObject);
							});
							const respData = {
								nodeData: { message: { data: { ...response.msg, attributes: updatedAttributes } } },
							};
							ref.setter({ ...respData, attributes: originalAttributes });
						} else if (node === NODE_TYPES.SEND_CAROUSEL) {
							ref.setter({ nodeData: response.msg });
						}
					} else if (!response.success) {
						ref.setter({ errorMsg: response.msg });
					}
				}
			})
			.catch((e) => console.error('OtherChannelNode.module.js: exception in fetchNodeDetails api', e));
	}

	async initData(props = {}) {
		this.data = {};
		this.setter(props);
		const response = await this.getNodeData(
			this.data.bot,
			this.data.node,
			this.data.user,
			this.data.locale,
			this.data.key
		);
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		const { bot, user, node, platform } = this.data;
		wrapper.classList.add('engt', 'engt-standalone');
		wrapper.id = 'engt-popup';
		if (isMobileOrTablet()) {
			wrapper.classList.add('engt-mobile-tab');
		}
		if (this.data.errorMsg) {
			wrapper.innerHTML = `<div style="color: red;">${this.data.errorMsg}</div>`;
			wrapper.classList.add('engt-redirect-open');
			this.html = wrapper;
			return;
		}
		wrapper.innerHTML = OtherChannelNodeTemplate();

		if (this.data.node === NODE_TYPES.FORM_NODE || this.data.node === NODE_TYPES.IDENTITY) {
			setCustomTagHTML(
				wrapper.querySelector('node'),
				new Form({
					...this.data.nodeData,
					otherChannelsData: {
						bot,
						platform,
						user,
						attributes: this.data.attributes,
						nodeType: this.data.node,
					},
				}).render()
			);
		} else {
			const defaultConfig = {
				layout: 'SHOW_ONE',
				type: 'SEAMLESS',
				orientation: 'VERTICAL',
			};

			const {
				templates = [],
				styleConfig: config = defaultConfig,
				footerButtons: footerBtns,
				headerButtons: headerBtns,
				...rest
			} = this.data.nodeData || {};

			const cards = templates?.length ? templates : [];

			if (cards.length) {
				const { orientation, layout, type } = config || defaultConfig;

				const carouselType = `${orientation}_${layout}_${type}`.toUpperCase();
				const cardsToUse = cards.map(({ image_url, image_alt_text, ...rest }, index) => ({
					image: image_url,
					imageAlt: image_alt_text || `carousel_image_${index}`,
					...rest,
				}));

				setCustomTagHTML(
					wrapper.querySelector('node'),
					new Carousel({
						...rest,
						footerBtns,
						headerBtns,
						config: config || {},
						id: `carouselNode-${generate6DigitUUID()}`,
						cards: cardsToUse,
						type: carouselType,
						popoverRole: POPOVER_ROLE.EXPANDABLE,
						ellipsis: {
							title: 2,
						},
						otherChannelsData: { bot, platform, user },
					}).render()
				);
			}
		}
		this.html = wrapper;
	}

	setter(props) {
		this.data = { ...this.data, ...props };
	}

	render() {
		return this.html;
	}
}
